/**
 * What a Track-POD order status says the driver did. Pure, so the sync and the frontend's timing
 * resolver (src/lib/stopTiming.ts) read the same two lists.
 *
 * Both vocabularies appear because the same order type carries collections and deliveries: a
 * collection route only expects the first, but a route with a haulage_delivery stop will
 * legitimately produce the second.
 */

/** The driver says they serviced the stop. */
export const TRACKPOD_SERVICED_STATUSES: ReadonlySet<string> = new Set([
  "Collected",
  "Delivered",
  "Partially",
])

/** The driver says they did not service it. */
export const TRACKPOD_NOT_SERVICED_STATUSES: ReadonlySet<string> = new Set([
  "Not Collected",
  "Not Delivered",
])
